/**
 * CKEditor plugin: render #ticket mentions as linked badges with ticket number + subject.
 */
export function TicketMentionCustomization(editor: any) {
  editor.conversion.for('upcast').elementToAttribute({
    view: {
      name: 'a',
      key: 'data-mention',
      classes: 'mention',
      attributes: {
        href: true,
      },
    },
    model: {
      key: 'mention',
      value: (viewItem: any) => {
        return editor.plugins.get('Mention').toMentionAttribute(viewItem, {
          link: viewItem.getAttribute('href'),
          subject: viewItem.getAttribute('data-ticket-subject') || undefined,
        });
      },
    },
    converterPriority: 'high',
  });

  editor.conversion.for('downcast').attributeToElement({
    model: 'mention',
    view: (modelAttributeValue: any, { writer, options }: any) => {
      if (!modelAttributeValue) {
        return;
      }

      const isTicketMention =
        modelAttributeValue.link &&
        String(modelAttributeValue.id || '').startsWith('#');

      if (isTicketMention) {
        return writer.createAttributeElement(
          'a',
          {
            class: 'mention',
            'data-mention': modelAttributeValue.id,
            href: modelAttributeValue.link,
            ...(modelAttributeValue.subject
              ? { 'data-ticket-subject': modelAttributeValue.subject }
              : {}),
            ...(!options.isClipboardPipeline
              ? { 'data-mention-uid': modelAttributeValue.uid }
              : {}),
          },
          {
            priority: 20,
            id: modelAttributeValue.uid,
          }
        );
      }

      return writer.createAttributeElement(
        'span',
        {
          class: 'mention',
          'data-mention': modelAttributeValue.id,
          ...(!options.isClipboardPipeline
            ? { 'data-mention-uid': modelAttributeValue.uid }
            : {}),
        },
        {
          priority: 20,
          id: modelAttributeValue.uid,
        }
      );
    },
    converterPriority: 'high',
  });
}

export function mapTicketMentionFeedItem(ticket: {
  _id?: string;
  ticket_number?: number | string;
  subject?: string;
}, appUrl: string) {
  const id = `#${ticket.ticket_number}`;
  const label = `${id} - ${ticket.subject || ''}`;

  return {
    id,
    link: `${appUrl}/admin/tickets/${ticket._id}`,
    name: label,
    text: label,
    subject: ticket.subject || '',
  };
}
